import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getUser } from '../../actions/profiles/usersActions'
import Swal from 'sweetalert2'
import { getClubsByUser } from '../../actions/profiles/clubsActions'
import { jwtDecode } from 'jwt-decode'
import Loader from '../../components/design/Loader/Loader'

export default function Dashboard({handleClientSelect,handleClubSelect}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {clientauth} = useAuth()
    const tokensave = sessionStorage.getItem('jwt')

    const {user} = useSelector(state=>state.users)
    const {resultclient} = useSelector(state=>state.clients)

    const {clubs,loadingclub} = useSelector(state=>state.clubs)
    const [token, setToken] = useState()

    useEffect(() =>{
        if(tokensave){
            setToken(jwtDecode(tokensave))
        }
    }, [tokensave])

    useEffect(() =>{
        if(token && clientauth){
            dispatch(getClubsByUser(clientauth?.id))
        }
    }, [token, dispatch, clientauth])

    useEffect(() => {
        if(clientauth){
            dispatch(getUser(clientauth?.id))
            handleClientSelect(clientauth?.client)
        }
    },[dispatch, t, clientauth, handleClientSelect])

    useEffect(() => {
        if(resultclient){
            let newresult = resultclient
            dispatch({
                type: 'CLIENT_RESET_RESULT'
            })
            switch (newresult) {
                case 'successactivate':
                    dispatch(getUser(clientauth?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('users.memberactivate')
                    })
                    break;
                case 'successdeactivate':
                    dispatch(getUser(clientauth?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('users.memberdeactivate')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultclient])        

    return (
        <Container className='cuerpo'>
            <div className='welcome-banner'>
                <div className='welcome-content'>
                    <span className='welcome-label'>{t('client.dashboard.welcome')}</span>
                    <h1 className='welcome-title'>{user?.username}</h1>
                    <p className='welcome-subtitle'>{t('client.dashboard.subwelcome')}</p>
                </div>
                <div className='welcome-icon'>
                    <i className="fas fa-user"></i>
                </div>
            </div>

            <div className='section-title'>
                <h2>{t('client.dashboard.yourClubs') || 'Tus clubes'}</h2>
            </div>
            <Row className='g-4'>
                { loadingclub
                ?
                    <Col><Loader/></Col>
                :
                    clubs?.map((club, index) => (
                    <Col key={index} xs={12} sm={6} lg={4}>
                        <div className='club-card' onClick={() => handleClubSelect(club._id)}>
                            <Link to={`/${t("url.club.club")}/${t("url.club.dashboard")}`} className='text-decoration-none'>
                                <div className='club-card-header'>
                                    <img
                                        src={club.avatar ? club.avatar : "/images/shield.png"}
                                        alt="Club"
                                        width={56}
                                        height={56}
                                        className='club-card-avatar'
                                    />
                                    <div className='club-card-info'>
                                        <h3>{club.name}</h3>
                                        <span className='club-card-badge'>
                                            <i className="fas fa-arrow-right"></i>
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Col>
                    ))
                }
            </Row>            
        </Container>
    )
}
